/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'orders-icon': {
    width: 22,
    height: 28,
    viewBox: '0 0 22 28',
    data: '<path pid="0" _fill="#FE8C10" fill-rule="evenodd" d="M15.719 23.82l.062-1.598-13.76-1.262-.064 1.142c-.037.648.557 1.3 1.343 1.408l12.748 1.858a3.243 3.243 0 0 1-.33-1.547zM3.107 24.845C1.65 24.642.522 23.404.599 22.028l.078-1.408c.035-.632.605-1.078 1.24-1.022l2.862.262.824-16.331c.028-.578.497-1.076 1.071-1.157L20.697.292c.715-.112 1.26.467 1.236 1.166l-.805 22.918c-.059 1.672-1.343 2.907-2.89 2.672L3.106 24.844zm12.97-3.948l-9.942-.911.821-16.293 13.608-2.02-.795 22.658c-.032.911-.636 1.492-1.327 1.386-.766-.116-1.399-.944-1.364-1.843l.067-1.712c.025-.632-.432-1.204-1.068-1.265zM18.412 7.19l.086-1.774-9.704.892-.06 1.629 9.678-.747zm-.209 4.373l.086-1.774-9.688.57-.06 1.628 9.662-.424zm-.282 4.404l.086-1.774-9.663.054-.06 1.629 9.637.091z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/orders-icon.js